export enum AuthSectionSteps {
  LOGIN = 'LOGIN',
  AUTHENTICATION = 'AUTHENTICATION',
  SELECT_COMPANY = 'SELECT_COMPANY',
  RECOVER_PASSWORD = 'RECOVER_PASSWORD',
  RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS',
  REDIRECT = 'REDIRECT',
  NO_LINKED_COMPANIES = 'NO_LINKED_COMPANIES',
  UNAUTHORIZED = 'UNAUTHORIZED',
}
